import React from "react";
import { ShieldCheck, Flame, Leaf, IndianRupee, Truck } from "lucide-react";
import FireParticles from "./FireParticles";
import { TID } from "@/lib/testIds";

const trust = [
  { icon: Leaf, label: "100% Ayurvedic" },
  { icon: ShieldCheck, label: "No Steroids" },
  { icon: Flame, label: "No Chemicals" },
  { icon: IndianRupee, label: "Safe Payments" },
  { icon: Truck, label: "Made in India" },
];

export default function Hero({ onBuy, bottleUrl, variant }) {
  const v = variant;
  return (
    <section className="relative overflow-hidden bg-black">
      {/* Fire glow layer */}
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[820px] w-[820px] -translate-x-1/2 rounded-full bg-fire-radial blur-2xl" />
      <FireParticles count={30} />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-6 px-5 pb-14 pt-8 sm:pt-14 lg:grid-cols-2 lg:gap-4 lg:pb-24 lg:pt-20">
        {/* Left: copy */}
        <div className="relative z-10 reveal">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#FF7A00]/40 bg-black/40 px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-[#FFC107] backdrop-blur">
            <Flame size={14} className="text-[#FF7A00]" />
            {v.badge}
          </div>
          <h1 className="font-display text-5xl leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
            {v.headlineA} <span className="text-fire">{v.headlineB}</span>
            {v.headlineD ? (
              <>
                <br />
                {v.headlineC} <span className="text-fire">{v.headlineD}</span>
              </>
            ) : (
              <>
                <br />
                <span className="text-fire">{v.headlineC}</span>
              </>
            )}
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-neutral-300 sm:text-lg">
            {v.subheading}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            {trust.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-neutral-200 backdrop-blur"
              >
                <Icon size={13} className="text-[#FFC107]" />
                {label}
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              data-testid={TID.heroBuyBtn}
              onClick={onBuy}
              className="group inline-flex items-center gap-2 rounded-full bg-fire px-8 py-4 font-bold uppercase tracking-widest text-black animate-pulse-orange transition-transform hover:scale-[1.03] active:scale-[0.98]"
            >
              {v.ctaLabel}
              <span className="rounded-full bg-black/85 px-2 py-0.5 text-[10px] text-[#FFC107]">
                63% OFF
              </span>
            </button>
            <div className="flex flex-col text-xs leading-tight text-neutral-400">
              <span>MRP <span className="line-through">₹2000</span></span>
              <span className="text-[#FFC107]">+ Free Gifts Worth ₹3000</span>
            </div>
          </div>
        </div>

        {/* Right: bottle */}
        <div className="relative order-first flex min-h-[300px] items-center justify-center lg:order-last lg:min-h-[560px]">
          <div className="pointer-events-none absolute inset-0 -z-0 bg-fire-radial blur-2xl" />
          <div className="relative animate-float">
            <div className="absolute -inset-6 rounded-[48px] bg-fire opacity-20 blur-3xl" />
            <img
              src={bottleUrl}
              alt="Bajrang Veda bottle"
              className="relative z-10 h-[280px] w-auto rounded-3xl object-contain drop-shadow-[0_20px_60px_rgba(255,122,0,0.5)] sm:h-[420px] lg:h-[540px]"
              loading="eager"
            />
            {/* floor reflection */}
            <div className="absolute inset-x-8 -bottom-2 h-6 rounded-full bg-[#FF7A00]/50 blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
